// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__xVBSl","vLegacy":"SelectSecondary_vLegacy__2nSSy","error":"SelectSecondary_error__8tyKb","disabled":"SelectSecondary_disabled__fTvCR"};